import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Panel/Panel.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "div";
var PANEL_CLASSNAME_MAP = {
  variant: {
    primary: "pd:panel--primary",
    secondary: "pd:panel--secondary"
  }
};
var Panel = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      variant = "primary",
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "variant", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  return /* @__PURE__ */jsx(Component, __spreadProps(__spreadValues({
    ref
  }, rest), {
    className: clsx("pd:panel", PANEL_CLASSNAME_MAP.variant[variant], className),
    children
  }));
});
var StoryPanel = args => /* @__PURE__ */jsx(Panel, __spreadValues({}, args));
var Panel_default = Panel;
export { PANEL_CLASSNAME_MAP, StoryPanel, Panel_default };